import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Header from "../Header";
import AppBar from "@mui/material/AppBar";
import Footer from "../Footer";
import Scroll from "../Header/Scroll";
import Banner from "./components/NomineeBanner";
import NomineePage from "./components/NomineePage";
import Image from "../../assets/banner/banner5b.jpg";

const styles = {
  paperContainer: {
    height: 500,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Nominees2022 = () => {
  return (
    <Box>
      <Helmet>
        <title> 2022 Nominees | BudgIT Active Citizens Awards</title>
      </Helmet>
      <Scroll>
        <AppBar position={"fixed"} elevation={0}>
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box style={styles.paperContainer}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box>
        <Container>
          <NomineePage />
        </Container>
      </Box>
      <Box bgcolor={"#049593"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Nominees2022;
